(function () {
  function formatMoneyEUR(cents) {
    var n = Number(cents);
    if (!Number.isFinite(n)) n = 0;
    var amount = n / 100;
    try {
      return (
        new Intl.NumberFormat('fr-FR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(amount) + ' €'
      );
    } catch (e) {
      return amount.toFixed(2) + ' €';
    }
  }

  function parseQty(input) {
    var v = parseInt(input.value, 10);
    if (!Number.isFinite(v) || v < 0) return 0;
    return v;
  }

  function readMatrixSettings(root) {
    return {
      productUrl: root.getAttribute('data-product-url') || '',
      productId: root.getAttribute('data-product-id') || '',
      stockRefreshEnabled:
        root.getAttribute('data-stock-refresh-enabled') === 'true',
      stockRefreshUrl: root.getAttribute('data-stock-refresh-url') || '',
      matrixSectionId: root.getAttribute('data-section-id') || '',
      sectionId:
        root.getAttribute('data-variant-json-section') ||
        'blanks-matrix-variant-json',
      colOptionIndex:
        parseInt(root.getAttribute('data-col-option-index'), 10) || 1,
      rowOptionIndex:
        parseInt(root.getAttribute('data-row-option-index'), 10) || 2,
      isLoggedIn: root.getAttribute('data-is-logged-in') === 'true',
      lowStockThreshold:
        parseInt(root.getAttribute('data-low-stock-threshold'), 10) || 8,
      msgOutOfStock:
        root.getAttribute('data-msg-out-of-stock') || 'Rupture',
      msgAvailable:
        root.getAttribute('data-msg-available') || 'Disponible',
      msgInStockSuffix:
        root.getAttribute('data-msg-in-stock-suffix') || 'en stock',
      qtyAriaPrefix:
        root.getAttribute('data-qty-aria-prefix') || 'Quantité',
      msgStockAdjusted:
        root.getAttribute('data-msg-stock-adjusted') ||
        'Stock mis à jour : certaines quantités ont été réduites au stock encore disponible. Vérifiez puis validez à nouveau.',
    };
  }

  function labelKey(colLabel, rowLabel) {
    return String(colLabel || '') + '\u0001' + String(rowLabel || '');
  }

  function normalizeAjaxVariant(v) {
    if (!v || v.id == null) return null;
    return {
      id: v.id,
      available: !!v.available,
      price: v.price,
      title: v.title || '',
      inventory_management: v.inventory_management || null,
      inventory_quantity: Number(v.inventory_quantity) || 0,
      inventory_policy: v.inventory_policy || 'deny',
      featured_image_src:
        v.featured_image && v.featured_image.src ? v.featured_image.src : null,
    };
  }

  function buildVariantMapFromProduct(product, settings) {
    var map = new Map();
    if (!product || !Array.isArray(product.variants)) return map;

    var colIdx = settings.colOptionIndex;
    var rowIdx = settings.rowOptionIndex;

    product.variants.forEach(function (v) {
      var opts = [v.option1, v.option2, v.option3];
      var col = opts[colIdx - 1];
      var row = opts[rowIdx - 1];
      if (col == null || row == null) return;
      map.set(labelKey(col, row), normalizeAjaxVariant(v));
    });

    return map;
  }

  function loadProductJsVariantMap(settings) {
    if (!settings.productUrl) return Promise.resolve(new Map());

    return fetch(settings.productUrl + '.js', { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('product.js failed');
        return res.json();
      })
      .then(function (product) {
        return buildVariantMapFromProduct(product, settings);
      })
      .catch(function () {
        return new Map();
      });
  }

  function parseVariantFromSectionHtml(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var script = doc.querySelector('[data-blanks-variant-json]');
    if (script && script.textContent) {
      try {
        var parsed = JSON.parse(script.textContent.trim());
        if (parsed && parsed.id != null) return parsed;
        return null;
      } catch (e) {
        /* fall through */
      }
    }

    var section = doc.querySelector('.shopify-section');
    var text = section ? section.textContent.trim() : String(html || '').trim();
    if (!text || text === 'null') return null;

    var start = text.indexOf('{');
    var end = text.lastIndexOf('}');
    if (start < 0 || end <= start) return null;
    try {
      var fallback = JSON.parse(text.slice(start, end + 1));
      if (fallback && fallback.id != null) return fallback;
      return null;
    } catch (e2) {
      return null;
    }
  }

  function buildSectionUrl(productUrl, sectionId, optionValues) {
    return (
      productUrl +
      '?section_id=' +
      encodeURIComponent(sectionId) +
      '&option_values=' +
      optionValues
    );
  }

  function fetchVariantViaSection(settings, optionValues) {
    if (!optionValues) return Promise.resolve(null);

    var url = buildSectionUrl(
      settings.productUrl,
      settings.sectionId,
      optionValues
    );

    return fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('section fetch failed');
        return res.text();
      })
      .then(function (html) {
        return parseVariantFromSectionHtml(html);
      });
  }

  function fetchVariantWithFallbacks(settings, entry) {
    var primary = entry.optionValues;
    var reversed = '';
    var parts = String(primary || '').split(',');
    if (parts.length === 2) {
      reversed = parts[1] + ',' + parts[0];
    }

    return fetchVariantViaSection(settings, primary)
      .then(function (variant) {
        if (variant) return variant;
        if (!reversed || reversed === primary) return null;
        return fetchVariantViaSection(settings, reversed);
      })
      .catch(function () {
        return null;
      });
  }

  function updateRowThumbnails(root, variantMap) {
    root.querySelectorAll('.blanks-matrix__thumb[data-row-label]').forEach(function (img) {
      var rowLabel = img.getAttribute('data-row-label');
      if (!rowLabel) return;

      variantMap.forEach(function (variant, key) {
        if (!variant || !variant.featured_image_src) return;
        var parts = key.split('\u0001');
        if (parts.length !== 2 || parts[1] !== rowLabel) return;
        img.src = variant.featured_image_src;
      });
    });
  }

  function buildStockHtml(variant, settings) {
    if (!variant) {
      return '<span class="blanks-matrix__cell--empty">—</span>';
    }

    var stockClass = 'blanks-matrix__stock-value';
    var stockHtml = '';
    var stockDotClass = '';
    var showShippingHint = false;

    if (!variant.available) {
      stockHtml = settings.msgOutOfStock;
      stockClass += ' is-out';
      stockDotClass = 'is-red';
    } else if (variant.inventory_management === 'shopify') {
      var qty = Number(variant.inventory_quantity) || 0;
      if (qty <= 0 && variant.inventory_policy === 'continue') {
        stockHtml = settings.msgAvailable;
      } else if (qty <= 0) {
        stockHtml = settings.msgOutOfStock;
        stockClass += ' is-out';
        stockDotClass = 'is-red';
      } else if (qty <= settings.lowStockThreshold) {
        stockHtml = qty + ' ' + settings.msgInStockSuffix;
        stockClass += ' is-low';
        stockDotClass = 'is-orange';
        showShippingHint = true;
      } else {
        stockHtml = qty + ' ' + settings.msgInStockSuffix;
        stockDotClass = 'is-green';
        showShippingHint = true;
      }
    } else {
      stockHtml = settings.msgAvailable;
      showShippingHint = true;
    }

    var html =
      '<div class="' +
      stockClass +
      '">' +
      (stockDotClass
        ? '<span class="blanks-matrix__stock-dot ' +
          stockDotClass +
          '" aria-hidden="true"></span>'
        : '') +
      stockHtml +
      '</div>';

    if (showShippingHint) {
      html +=
        '<div class="blanks-matrix__shipping-hint">' +
        '<span class="blanks-matrix__shipping-flash" aria-hidden="true">⚡</span>' +
        'Expedition en 24/48h' +
        '</div>';
    }

    return html;
  }

  function buildTierStockHtml(variant, settings) {
    if (!variant) {
      return '<span class="blanks-matrix__cell--empty">—</span>';
    }

    var stockClass = 'blanks-matrix__stock-value';
    var stockHtml = '';

    if (!variant.available) {
      stockHtml = settings.msgOutOfStock;
      stockClass += ' is-out';
    } else if (variant.inventory_management === 'shopify') {
      var qty = Number(variant.inventory_quantity) || 0;
      if (qty <= 0 && variant.inventory_policy === 'continue') {
        stockHtml = settings.msgAvailable;
      } else if (qty <= 0) {
        stockHtml = settings.msgOutOfStock;
        stockClass += ' is-out';
      } else {
        stockHtml = String(qty);
        if (qty <= settings.lowStockThreshold) {
          stockClass += ' is-low';
        }
      }
    } else {
      stockHtml = settings.msgAvailable;
    }

    return '<span class="' + stockClass + '">' + stockHtml + '</span>';
  }

  function buildTierPriceHtml(variant, multiplier, settings) {
    if (!variant) {
      return '<span class="blanks-matrix__cell--empty">—</span>';
    }

    if (!settings.isLoggedIn) {
      var lockedExamples = {
        100: '4,94 €',
        90: '4,45 €',
        80: '3,95 €',
        70: '3,46 €'
      };
      return (
        '<span class="blanks-matrix__tier-price is-locked" aria-label="Prix masqué"><span aria-hidden="true">' +
        (lockedExamples[multiplier] || '4,94 €') +
        '</span></span>'
      );
    }

    var cents = Math.round((Number(variant.price) || 0) * multiplier / 100);
    return (
      '<span class="blanks-matrix__tier-price' +
      (multiplier < 100 ? ' is-discount' : '') +
      '">' +
      formatMoneyEUR(cents) +
      '</span>'
    );
  }

  function buildTierQtyInputHtml(variant, settings, rowLabel, colLabel) {
    var disabled = !variant || !variant.available || !settings.isLoggedIn;
    var maxQ = 9999;

    if (
      variant &&
      variant.inventory_management === 'shopify' &&
      variant.inventory_policy !== 'continue'
    ) {
      maxQ = Number(variant.inventory_quantity) || 0;
      if (maxQ < 0) maxQ = 0;
    }

    var aria =
      settings.qtyAriaPrefix + ' ' + rowLabel + ' — ' + colLabel;

    return (
      '<input class="blanks-matrix__qty blanks-matrix__tier-qty" type="number" min="0" value="0"' +
      (disabled ? ' disabled' : ' max="' + maxQ + '"') +
      (!disabled && variant ? ' data-variant-id="' + variant.id + '"' : '') +
      (!disabled && variant ? ' data-price-cents="' + variant.price + '"' : '') +
      ' aria-label="' +
      aria.replace(/"/g, '&quot;') +
      '" inputmode="numeric">'
    );
  }

  function buildQtyControlHtml(variant, settings, rowLabel, colLabel, disabled) {
    var aria =
      settings.qtyAriaPrefix + ' ' + rowLabel + ' — ' + colLabel;
    var maxQ = 9999;
    var variantId = '';
    var priceCents = '';

    if (variant && !disabled) {
      variantId = String(variant.id);
      priceCents = String(variant.price);
      if (
        variant.inventory_management === 'shopify' &&
        variant.inventory_policy !== 'continue'
      ) {
        maxQ = Number(variant.inventory_quantity) || 0;
        if (maxQ < 0) maxQ = 0;
      }
    }

    var disabledAttr = disabled ? ' disabled tabindex="-1"' : '';
    var maxAttr = disabled ? '' : ' max="' + maxQ + '"';
    var variantAttr = variantId
      ? ' data-variant-id="' + variantId + '"'
      : '';
    var priceAttr = priceCents
      ? ' data-price-cents="' + priceCents + '"'
      : '';

    return (
      '<div class="blanks-matrix__qty-wrap' +
      (disabled ? ' is-disabled' : '') +
      '">' +
      '<button type="button" class="blanks-matrix__qty-btn" data-qty-decr' +
      disabledAttr +
      ' aria-label="Diminuer la quantité">' +
      '<span class="blanks-matrix__qty-icon" aria-hidden="true">' +
      '<svg viewBox="0 0 20 20" focusable="false" role="presentation">' +
      '<path d="M4.5 10a.75.75 0 0 1 .75-.75h9.5a.75.75 0 0 1 0 1.5h-9.5A.75.75 0 0 1 4.5 10Z"></path>' +
      '</svg></span></button>' +
      '<input class="blanks-matrix__qty" type="number" min="0" value="0"' +
      maxAttr +
      (disabled ? ' disabled' : '') +
      variantAttr +
      priceAttr +
      ' aria-label="' +
      aria.replace(/"/g, '&quot;') +
      '" inputmode="numeric">' +
      '<button type="button" class="blanks-matrix__qty-btn" data-qty-incr' +
      disabledAttr +
      ' aria-label="Augmenter la quantité">' +
      '<span class="blanks-matrix__qty-icon" aria-hidden="true">' +
      '<svg viewBox="0 0 20 20" focusable="false" role="presentation">' +
      '<path d="M10 4.5a.75.75 0 0 1 .75.75v4h4a.75.75 0 0 1 0 1.5h-4v4a.75.75 0 0 1-1.5 0v-4h-4a.75.75 0 0 1 0-1.5h4v-4A.75.75 0 0 1 10 4.5Z"></path>' +
      '</svg></span></button></div>'
    );
  }

  function fillTierRow(row, variant, settings, rowLabel, colLabel) {
    if (!row) return;

    if (!variant || !variant.available) {
      row.classList.add('is-unavailable');
    } else {
      row.classList.remove('is-unavailable');
    }

    row.querySelectorAll('[data-tier-price]').forEach(function (cell) {
      var multiplier = parseInt(cell.getAttribute('data-tier-price'), 10) || 100;
      cell.innerHTML = buildTierPriceHtml(variant, multiplier, settings);
    });

    var stockCell = row.querySelector('[data-tier-stock]');
    if (stockCell) {
      stockCell.innerHTML = buildTierStockHtml(variant, settings);
    }

    var qtyCell = row.querySelector('[data-tier-qty]');
    if (qtyCell) {
      qtyCell.innerHTML = buildTierQtyInputHtml(
        variant,
        settings,
        rowLabel,
        colLabel
      );
    }

    row.removeAttribute('data-blanks-hydrate');
  }

  function buildBuyHtml(variant, settings, rowLabel, colLabel) {
    if (!variant) {
      return '<span class="blanks-matrix__cell--empty">—</span>';
    }

    var priceHtml = settings.isLoggedIn
      ? '<div class="blanks-matrix__price">' +
        formatMoneyEUR(variant.price) +
        '</div>'
      : '<div class="blanks-matrix__price is-locked" aria-label="Prix masqué"><span aria-hidden="true">4,94 €</span></div>';

    var disabled =
      !variant.available || !settings.isLoggedIn;

    return (
      priceHtml +
      buildQtyControlHtml(
        variant,
        settings,
        rowLabel,
        colLabel,
        disabled
      )
    );
  }

  function fillHydratedCells(entry, variant, settings) {
    if (entry.rowEl) {
      fillTierRow(
        entry.rowEl,
        variant,
        settings,
        entry.rowLabel,
        entry.colLabel
      );
    }
    if (entry.stockTd) {
      entry.stockTd.innerHTML = buildStockHtml(variant, settings);
      entry.stockTd.removeAttribute('data-blanks-hydrate');
    }
    if (entry.buyTd) {
      entry.buyTd.innerHTML = buildBuyHtml(
        variant,
        settings,
        entry.rowLabel,
        entry.colLabel
      );
      entry.buyTd.removeAttribute('data-blanks-hydrate');
    }
  }

  function hydrateMissingCells(root, settings) {
    var cells = root.querySelectorAll('[data-blanks-hydrate]');
    if (!cells.length || !settings.productUrl) {
      return Promise.resolve(new Map());
    }

    var pairs = new Map();
    cells.forEach(function (td) {
      var key = td.getAttribute('data-option-values');
      if (!key) return;
      if (!pairs.has(key)) {
        pairs.set(key, {
          optionValues: key,
          rowLabel: td.getAttribute('data-row-label') || '',
          colLabel: td.getAttribute('data-col-label') || '',
          stockTd: null,
          buyTd: null,
          rowEl: null,
          resolved: false,
        });
      }
      var rec = pairs.get(key);
      var kind = td.getAttribute('data-blanks-hydrate');
      if (kind === 'stock') rec.stockTd = td;
      if (kind === 'buy') rec.buyTd = td;
      if (kind === 'tier-row') rec.rowEl = td;
    });

    var entries = Array.from(pairs.values());
    if (!entries.length) return Promise.resolve(new Map());

    var variantMap = new Map();

    function resolveFromMap(entry) {
      var variant = variantMap.get(labelKey(entry.colLabel, entry.rowLabel));
      if (!variant) return false;
      fillHydratedCells(entry, variant, settings);
      entry.resolved = true;
      return true;
    }

    return loadProductJsVariantMap(settings)
      .then(function (ajaxMap) {
        ajaxMap.forEach(function (variant, key) {
          variantMap.set(key, variant);
        });

        entries.forEach(function (entry) {
          resolveFromMap(entry);
        });

        var pending = entries.filter(function (entry) {
          return !entry.resolved;
        });
        if (!pending.length) return variantMap;

        var concurrency = 6;
        var index = 0;

        function fetchNext() {
          if (index >= pending.length) return Promise.resolve();
          var entry = pending[index++];
          if (entry.resolved) return fetchNext();

          return fetchVariantWithFallbacks(settings, entry)
            .then(function (variant) {
              if (variant) {
                variantMap.set(
                  labelKey(entry.colLabel, entry.rowLabel),
                  variant
                );
                fillHydratedCells(entry, variant, settings);
                entry.resolved = true;
              } else {
                fillHydratedCells(entry, null, settings);
              }
            })
            .then(fetchNext);
        }

        var workers = [];
        for (var i = 0; i < Math.min(concurrency, pending.length); i++) {
          workers.push(fetchNext());
        }
        return Promise.all(workers).then(function () {
          return variantMap;
        });
      })
      .then(function (variantMap) {
        updateRowThumbnails(root, variantMap);
        return variantMap;
      });
  }

  function bindQtyInputs(root, onChange) {
    root.querySelectorAll('.blanks-matrix__qty').forEach(function (input) {
      if (input.getAttribute('data-qty-bound') === '1') return;
      input.setAttribute('data-qty-bound', '1');
      input.addEventListener('input', function () {
        var max = parseInt(input.getAttribute('max'), 10);
        if (Number.isFinite(max) && parseQty(input) > max) {
          input.value = String(max);
        }
        onChange();
      });
      input.addEventListener('change', onChange);
    });
  }

  // Ask the backend to refresh THIS Imbretex product stock before reading
  // inventory on the PDP. Best-effort and time-capped: if the backend is slow
  // or unavailable, the matrix still renders with current Shopify stock.
  function refreshStockFromImbretex(settings) {
    if (
      !settings.stockRefreshEnabled ||
      !settings.stockRefreshUrl ||
      !settings.productId
    ) {
      return Promise.resolve(null);
    }

    var controller =
      typeof window.AbortController === 'function'
        ? new window.AbortController()
        : null;
    var timer = window.setTimeout(function () {
      if (controller) controller.abort();
    }, 15000);

    return fetch(settings.stockRefreshUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ productId: String(settings.productId) }),
      signal: controller ? controller.signal : undefined,
    })
      .then(function (res) {
        return res && res.ok
          ? res.json().catch(function () {
              return null;
            })
          : null;
      })
      .catch(function () {
        return null;
      })
      .then(function (result) {
        window.clearTimeout(timer);
        return result;
      });
  }

  // Fetch a fresh server-rendered copy of the matrix section and read each
  // variant's current max quantity. Liquid is used because product.js may hide
  // inventory_quantity on the storefront.
  function fetchFreshAvailability(settings) {
    if (!settings.matrixSectionId || !settings.productUrl) {
      return Promise.resolve(null);
    }

    var url =
      settings.productUrl +
      '?section_id=' +
      encodeURIComponent(settings.matrixSectionId);

    return fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('section render failed');
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inputs = doc.querySelectorAll('input[data-variant-id]');
        if (!inputs.length) return null;

        var map = new Map();
        inputs.forEach(function (el) {
          var id = el.getAttribute('data-variant-id');
          var maxAttr = el.getAttribute('max');
          if (!id || maxAttr == null) return;
          var n = parseInt(maxAttr, 10);
          if (Number.isFinite(n)) map.set(String(id), n);
        });
        return map.size ? map : null;
      })
      .catch(function () {
        return null;
      });
  }

  // Current cart quantities by variant id, so the add-to-cart check clamps
  // against remaining stock, not raw Shopify stock.
  function fetchCartQuantities() {
    var url =
      (window.theme && theme.routes && theme.routes.cart_url
        ? theme.routes.cart_url
        : '/cart') + '.js';

    return fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('cart.js failed');
        return res.json();
      })
      .then(function (cart) {
        var map = new Map();
        (cart && cart.items ? cart.items : []).forEach(function (line) {
          if (line && line.id != null) {
            var key = String(line.id);
            map.set(key, (map.get(key) || 0) + (Number(line.quantity) || 0));
          }
        });
        return map;
      })
      .catch(function () {
        return new Map();
      });
  }

  // After a successful backend stock refresh, re-render the whole matrix section
  // so all stock labels, disabled states and input max values use fresh Shopify
  // inventory. Re-init with skipRefresh to avoid an infinite refresh loop.
  function rerenderMatrixSection(oldRoot, settings) {
    if (!settings.matrixSectionId || !settings.productUrl) {
      return Promise.resolve(false);
    }

    var url =
      settings.productUrl +
      '?section_id=' +
      encodeURIComponent(settings.matrixSectionId);

    return fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('section render failed');
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.blanks-matrix');
        if (!fresh || !oldRoot.parentNode) return false;

        fresh.removeAttribute('data-blanks-matrix-init');
        oldRoot.replaceWith(fresh);
        initSection(fresh, { skipRefresh: true });
        return true;
      })
      .catch(function () {
        return false;
      });
  }

  function initSection(root, opts) {
    opts = opts || {};
    if (!root || root.getAttribute('data-blanks-matrix-init') === '1') return;
    root.setAttribute('data-blanks-matrix-init', '1');

    var qtyInputs = root.querySelectorAll('.blanks-matrix__qty');
    var totalEls = root.querySelectorAll('[data-blanks-matrix-total]');
    var submitBtn = root.querySelector('[data-blanks-matrix-submit]');
    var submitLabel = root.querySelector('[data-submit-label]');
    var errorEl = root.querySelector('[data-blanks-matrix-error]');
    var galleryModal = root.querySelector('[data-row-gallery-modal]');
    var galleryImage = root.querySelector('[data-gallery-image]');
    var galleryCaption = root.querySelector('[data-gallery-caption]');
    var galleryPrev = root.querySelector('[data-gallery-prev]');
    var galleryNext = root.querySelector('[data-gallery-next]');
    var galleryItems = [];
    var galleryIndex = 0;
    var matrixSettings = readMatrixSettings(root);

    function refreshQtyInputs() {
      qtyInputs = root.querySelectorAll('.blanks-matrix__qty');
    }

    function setError(msg) {
      if (!errorEl) return;
      if (msg) {
        errorEl.textContent = msg;
        errorEl.classList.add('is-visible');
      } else {
        errorEl.textContent = '';
        errorEl.classList.remove('is-visible');
      }
    }

    function computeTotalCents() {
      refreshQtyInputs();
      var sum = 0;
      qtyInputs.forEach(function (input) {
        if (input.disabled) return;
        var cents = parseInt(input.getAttribute('data-price-cents'), 10) || 0;
        sum += parseQty(input) * cents;
      });
      return sum;
    }

    function updateTotal() {
      refreshQtyInputs();
      totalEls = root.querySelectorAll('[data-blanks-matrix-total]');
      totalEls.forEach(function (totalEl) {
        totalEl.textContent = formatMoneyEUR(computeTotalCents());
      });
      var any =
        Array.prototype.some.call(qtyInputs, function (inp) {
          return !inp.disabled && parseQty(inp) > 0;
        });
      if (submitBtn) submitBtn.disabled = !any;
    }

    function updateHeaderCartCount() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('cart.js failed');
          return res.json();
        })
        .then(function (cart) {
          var count = String((cart && cart.item_count) || 0);
          document.querySelectorAll('.thb-item-count').forEach(function (el) {
            el.textContent = count;
          });
        })
        .catch(function () {
          // Do not block UX if cart count refresh fails.
        });
    }

    function showAddedFeedback() {
      if (!submitBtn || !submitLabel) return;
      if (!submitBtn.dataset.defaultLabel) {
        submitBtn.dataset.defaultLabel = submitLabel.textContent || '';
      }
      submitBtn.classList.add('is-success');
      submitLabel.textContent = 'Ajoute au panier';
      window.setTimeout(function () {
        submitBtn.classList.remove('is-success');
        submitLabel.textContent =
          submitBtn.dataset.defaultLabel || 'Ajouter a mon panier';
      }, 1800);
    }

    function renderGallery() {
      if (!galleryItems.length || !galleryImage) return;
      var item = galleryItems[galleryIndex] || galleryItems[0];
      galleryImage.src = item.src || '';
      galleryImage.alt = item.alt || '';
      if (galleryCaption) {
        galleryCaption.textContent = item.alt || '';
      }
      var showNav = galleryItems.length > 1;
      if (galleryPrev) galleryPrev.hidden = !showNav;
      if (galleryNext) galleryNext.hidden = !showNav;
    }

    function closeGallery() {
      if (!galleryModal) return;
      galleryModal.setAttribute('hidden', 'hidden');
      document.body.classList.remove('blanks-gallery-open');
      galleryItems = [];
      galleryIndex = 0;
      if (galleryImage) {
        galleryImage.src = '';
        galleryImage.alt = '';
      }
    }

    function openGallery(items) {
      if (!galleryModal || !items || !items.length) return;
      galleryItems = items;
      galleryIndex = 0;
      renderGallery();
      galleryModal.removeAttribute('hidden');
      document.body.classList.add('blanks-gallery-open');
    }

    bindQtyInputs(root, function () {
      setError('');
      updateTotal();
    });

    function hydrateAndFinalize() {
      return hydrateMissingCells(root, matrixSettings)
        .then(function () {
          bindQtyInputs(root, function () {
            setError('');
            updateTotal();
          });
          updateTotal();
        })
        .catch(function () {
          updateTotal();
        });
    }

    if (opts.skipRefresh || !matrixSettings.stockRefreshEnabled) {
      hydrateAndFinalize();
    } else {
      refreshStockFromImbretex(matrixSettings)
        .catch(function () {
          return null;
        })
        .then(function () {
          return rerenderMatrixSection(root, matrixSettings);
        })
        .then(function (didRerender) {
          if (didRerender) return;
          return hydrateAndFinalize();
        })
        .catch(function () {
          updateTotal();
        });
    }

    root.addEventListener('click', function (e) {
      var colorTrigger = e.target.closest('[data-color-trigger]');
      if (colorTrigger && root.contains(colorTrigger)) {
        var colorValue = colorTrigger.getAttribute('data-color-trigger') || '';
        root.querySelectorAll('[data-color-trigger]').forEach(function (button) {
          var active = button === colorTrigger;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        root.querySelectorAll('[data-color-panel]').forEach(function (panel) {
          var active = panel.getAttribute('data-color-panel') === colorValue;
          panel.classList.toggle('is-active', active);
          if (active) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', 'hidden');
          }
        });
        var selected = root.querySelector('[data-blanks-selected-color]');
        if (selected) selected.textContent = colorValue;
        return;
      }

      var thumb = e.target.closest('[data-row-gallery]');
      if (thumb && root.contains(thumb)) {
        var raw = thumb.getAttribute('data-row-gallery') || '[]';
        var parsed = raw
          .split('||')
          .map(function (chunk) {
            if (!chunk) return null;
            var parts = chunk.split('~~');
            return {
              src: parts[0] || '',
              alt: parts.slice(1).join('~~') || '',
            };
          })
          .filter(Boolean);
        if (Array.isArray(parsed) && parsed.length) {
          openGallery(parsed);
        }
        return;
      }

      var btn = e.target.closest('[data-qty-decr], [data-qty-incr]');
      if (!btn || !root.contains(btn) || btn.disabled) return;
      var wrap = btn.closest('.blanks-matrix__qty-wrap');
      if (!wrap) return;
      var input = wrap.querySelector('.blanks-matrix__qty');
      if (!input || input.disabled) return;
      var max = parseInt(input.getAttribute('max'), 10);
      var q = parseQty(input);
      if (btn.hasAttribute('data-qty-decr')) {
        q = Math.max(0, q - 1);
      } else {
        q = q + 1;
        if (Number.isFinite(max) && q > max) q = max;
      }
      input.value = String(q);
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });

    if (galleryModal) {
      galleryModal.addEventListener('click', function (e) {
        if (e.target.closest('[data-gallery-close]')) {
          closeGallery();
        }
      });
      if (galleryPrev) {
        galleryPrev.addEventListener('click', function () {
          if (!galleryItems.length) return;
          galleryIndex =
            (galleryIndex - 1 + galleryItems.length) % galleryItems.length;
          renderGallery();
        });
      }
      if (galleryNext) {
        galleryNext.addEventListener('click', function () {
          if (!galleryItems.length) return;
          galleryIndex = (galleryIndex + 1) % galleryItems.length;
          renderGallery();
        });
      }
      document.addEventListener('keydown', function (e) {
        if (!galleryModal || galleryModal.hasAttribute('hidden')) return;
        if (e.key === 'Escape') closeGallery();
        if (e.key === 'ArrowLeft' && galleryItems.length > 1) {
          galleryIndex =
            (galleryIndex - 1 + galleryItems.length) % galleryItems.length;
          renderGallery();
        }
        if (e.key === 'ArrowRight' && galleryItems.length > 1) {
          galleryIndex = (galleryIndex + 1) % galleryItems.length;
          renderGallery();
        }
      });
    }

    updateTotal();

    if (!submitBtn) return;

    function addItemsToCart(cartItems) {
      var url =
        (window.theme && theme.routes && theme.routes.cart_add_url) ||
        '/cart/add.js';
      var payload = { items: cartItems };

      return fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(payload),
      })
        .then(function (res) {
          return res.json().then(function (body) {
            return { ok: res.ok, status: res.status, body: body };
          });
        })
        .then(function (result) {
          if (!result.ok) {
            var desc = result.body && result.body.description;
            if (desc && typeof desc === 'object') {
              desc =
                desc.base ||
                (Array.isArray(desc)
                  ? desc.join(', ')
                  : JSON.stringify(desc));
            }
            var msg =
              (typeof desc === 'string' && desc) ||
              (result.body && result.body.message) ||
              "Impossible d'ajouter au panier.";
            throw new Error(msg);
          }

          document.dispatchEvent(new CustomEvent('cart:refresh'));

          if (typeof window.dispatchCustomEvent === 'function') {
            window.dispatchCustomEvent('cart:item-added', {
              product: result.body,
            });
          }

          updateHeaderCartCount();
          showAddedFeedback();

          var mode = root.getAttribute('data-after-add') || 'stay';
          if (mode === 'cart') {
            window.location.href =
              (window.theme && theme.routes && theme.routes.cart_url) ||
              '/cart';
            return;
          }
          if (
            mode === 'drawer' &&
            window.theme &&
            theme.settings &&
            theme.settings.cart_drawer
          ) {
            document.body.classList.add('open-cc');
            var drawer = document.getElementById('Cart-Drawer');
            if (drawer) drawer.classList.add('active');
            if (typeof window.dispatchCustomEvent === 'function') {
              window.dispatchCustomEvent('cart-drawer:open');
            }
          }

          qtyInputs.forEach(function (inp) {
            if (!inp.disabled) inp.value = '0';
          });
          updateTotal();
        });
    }

    submitBtn.addEventListener('click', function () {
      setError('');
      refreshQtyInputs();
      var items = [];

      qtyInputs.forEach(function (input) {
        if (input.disabled) return;
        var q = parseQty(input);
        if (q <= 0) return;
        var id = input.getAttribute('data-variant-id');
        if (!id) return;
        items.push({ id: Number(id), quantity: q });
      });

      if (!items.length) {
        setError(
          root.getAttribute('data-msg-select-qty') ||
            'Indiquez au moins une quantité.'
        );
        return;
      }

      submitBtn.classList.add('is-loading');
      submitBtn.disabled = true;

      function done() {
        submitBtn.classList.remove('is-loading');
        submitBtn.disabled = computeTotalCents() <= 0;
      }

      function addOriginalItems() {
        return addItemsToCart(items)
          .catch(function (err) {
            setError(err.message || 'Erreur réseau.');
          })
          .then(done);
      }

      // Final stock check before add-to-cart. A customer can leave the PDP open
      // for a while, so we refresh Imbretex → Shopify again, read a fresh
      // server-rendered matrix and soft-clamp quantities to remaining stock.
      // If quantities are reduced, we stop and ask the customer to validate
      // again instead of silently adding fewer items than requested.
      refreshStockFromImbretex(matrixSettings)
        .catch(function () {
          return null;
        })
        .then(function () {
          if (!matrixSettings.stockRefreshEnabled) return [null, new Map()];
          return Promise.all([
            fetchFreshAvailability(matrixSettings),
            fetchCartQuantities(),
          ]);
        })
        .then(function (results) {
          var availMap = results && results[0];
          var cartMap = (results && results[1]) || new Map();
          var adjusted = 0;

          if (availMap && availMap.size) {
            items.forEach(function (item) {
              var key = String(item.id);
              var stock = availMap.has(key) ? availMap.get(key) : 0;
              var remaining = Math.max(0, stock - (cartMap.get(key) || 0));
              var allowed = Math.max(0, Math.min(item.quantity, remaining));

              if (allowed < item.quantity) {
                adjusted += 1;
                var liveInput = root.querySelector(
                  'input[data-variant-id="' + key + '"]'
                );
                if (liveInput) liveInput.value = String(allowed);
              }
            });
          }

          if (adjusted > 0) {
            refreshQtyInputs();
            updateTotal();
            setError(matrixSettings.msgStockAdjusted);
            done();
            return null;
          }

          return addOriginalItems();
        })
        .catch(function () {
          return addOriginalItems();
        });
    });
  }

  function boot() {
    document.querySelectorAll('.blanks-matrix').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target && ev.target.querySelector) {
      var sec = ev.target.querySelector('.blanks-matrix');
      if (sec) initSection(sec);
    }
  });
})();